import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../../constants/API";
import { OptionType } from "./ISBNSReducer";

interface Author1datainterface {
  _id: string;
  AUTHOR_1: string;
}

interface Author1State {
  data: Author1datainterface[];
  hasMoreAuthor: boolean;
  status: string;
  statusCode: number;
  error: string | null;
  isLoading: boolean;
  Author1?: string[];
  Author1List?: OptionType[];
  authorString: string;
  page: number;
  limit: number;
  fetchType: string | undefined;
}
const initialState: Author1State = {
  data: [],
  page: 1,
  limit: 15,
  hasMoreAuthor: false,
  authorString: "",
  status: "",
  error: null,
  statusCode: 0,
  isLoading: false,
  Author1: [],
  Author1List: [],
  fetchType: "",
};

export const FetchAuthor1 = createAsyncThunk(
  "FetchAuthor1",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.post(API.FetchAuthor1, data);
      return response;
    } catch (err: any) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue("error occurred");
    }
  }
);

const Author1Slice = createSlice({
  name: "Author1Data",
  initialState,
  reducers: {
    addPage: (state) => {
      if (state.hasMoreAuthor) state.page += 1;
    },
    updateAuthorPage: (state, action) => {
      state.page = action.payload;
    },
    UpdateAuthor1: (state, action) => {
      state.Author1 = action.payload;
    },
    UpdateAuthor1List: (state, action) => {
      state.Author1List = action.payload;
    },
    emptyAuthorReducer: (state) => {
      state.data = initialState.data;
      state.status = initialState.status;
      state.error = initialState.error;
      state.isLoading = initialState.isLoading;
      state.Author1 = initialState.Author1;
      state.Author1List = initialState.Author1List;
    },
    setAuthorString: (state, action) => {
      state.authorString = action.payload;
    },
    resetAuthorPage: (state) => {
      state.page = initialState.page;
    },
    removeAuthorFetchType: (state) => {
      state.fetchType = undefined;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(FetchAuthor1.pending, (state) => {
        state.isLoading = true;
        state.status = "Loading";
      })
      .addCase(FetchAuthor1.fulfilled, (state, action) => {
        state.status = "success";

        state.hasMoreAuthor = action.payload.data.hasMore;

        if (action.payload.data.filteredNew || state.page === 1) {
          state.page = initialState.page;
          state.data = action.payload.data.data;
          state.fetchType = action.payload.data.fetchType;
        } else {
          const filteredAuthors = action.payload.data.data.filter(
            (author: any) =>
              !state.data
                ?.map((stateAuthor) => stateAuthor._id)
                .includes(author._id)
          );
          action.payload.data.data?.length &&
            state.data.push(...filteredAuthors);
        }

        state.isLoading = false;
      })
      .addCase(FetchAuthor1.rejected, (state) => {
        state.isLoading = false;
        state.status = "Failed";
        state.error = "Error";
      });
  },
});
export const {
  resetAuthorPage,
  UpdateAuthor1,
  UpdateAuthor1List,
  emptyAuthorReducer,
  setAuthorString,
  addPage,
  updateAuthorPage,
  removeAuthorFetchType,
} = Author1Slice.actions;
export default Author1Slice.reducer;
